import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e0d8757"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"width":"60px"},
  class: "rel"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "abs big-img"
}
const _hoisted_4 = { class: "tag-content" }
const _hoisted_5 = ["src"]

import { tagsMap } from '@/common/const'
import { t } from '@/plugins/i18n'
import { ref } from 'vue'
import SvgIcon from '@/components/icons/SvgIcon.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['imgs'],
  setup(__props) {

const props = __props
const csl = ref()

const img:any = ref({})
const mouseover = (v:any) => {
  img.value = v
}
const mouseout = (v: string) => {
  img.value = {}
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_carousel, {
      ref: (_value, _refs) => {
        _refs['csl'] = _value
        csl.value = _value
      },
      height: "60px",
      arrow: "never",
      trigger: "click"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.imgs, (v) => {
          return (_openBlock(), _createBlock(_component_el_carousel_item, { key: v }, {
            default: _withCtx(() => [
              _createElementVNode("a", {
                href: v.image,
                target: "_blank",
                class: "rel prew-img"
              }, [
                _createVNode(_component_el_image, {
                  referrerPolicy: "no-referrer",
                  class: "carousel-img",
                  "data-goods": "",
                  src: v.image,
                  onMouseover: ($event: any) => (mouseover(v)),
                  onMouseout: ($event: any) => (mouseout(v))
                }, null, 8, ["src", "onMouseover", "onMouseout"]),
                (!img.value)
                  ? (_openBlock(), _createBlock(SvgIcon, {
                      key: 0,
                      name: "放大",
                      class: "abs icon1",
                      style: {"bottom":"4px","right":"4px","font-size":"20px"}
                    }))
                  : _createCommentVNode("", true),
                (img.value)
                  ? (_openBlock(), _createBlock(SvgIcon, {
                      key: 1,
                      name: "放大_active",
                      class: "abs icon2",
                      style: {"bottom":"4px","right":"4px","font-size":"20px"}
                    }))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_2)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createElementVNode("div", {
          class: "abs arrow aw-lf btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (csl.value.prev()))
        }),
        _createElementVNode("div", {
          class: "abs arrow aw-rt btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (csl.value.next()))
        })
      ]),
      _: 1
    }, 512),
    (img.value.image)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(img.value.tags, (tagItem) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "tag",
                key: tagItem
              }, _toDisplayString(_unref(tagsMap)[tagItem]), 1))
            }), 128))
          ]),
          _createElementVNode("img", {
            referrerPolicy: "no-referrer",
            src: img.value.image,
            alt: ""
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})